<template>
  <div class="row transaction">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
      "
    >
      <h1
        class="p-0, m-0"
        style="font-size: 25px; text-transform: uppercase; font-weight: 700"
      >
        Terminals
      </h1>
      <div style="display: flex; gap: 10px">
        <router-link
          class="btn btn-info"
          to="/dashboard/ptspterminal-configuration"
          :style="{ display: isInstitution ? 'none' : 'block' }"
        >
          Terminal Configuration</router-link
        >
        <router-link class="btn btn-info" to="/dashboard/add-ptsp-terminal">
          <i class="fa fa-plus"></i>
          Add Terminal</router-link
        >
        <router-link class="btn btn-info" to="/dashboard/upload-ptspterminal">
          Upload Terminal</router-link
        >
      </div>
    </div>

    <div class="col-12 p-0 d-flex align-items-center">
      <div class="form-row align-items-center">
        <div class="col-auto mt-3">
          <!-- <label for="inlineFormInput">Select a search parameter</label> -->
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="terminalId">Terminal Id</option>
            <option value="serialNo">Serial Number</option>
            <option value="merchantId">Merchant Id</option>
            <option value="salesOfficer">Sales Officer</option>
            <option value="configurationStatus">Configuration Status</option>
          </select>
        </div>

        <div
          class="col-auto mt-4"
          v-if="selectedValue && selectedValue !== 'configurationStatus'"
        >
          <div class="input-group mb-2">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div
          class="col-auto mt-4"
          v-if="selectedValue === 'configurationStatus'"
        >
          <select
            class="form-control mb-2"
            v-model="searchValues[selectedValue]"
            placeholder="Select a search parameter"
          >
            <option value="">Select a configuration status</option>
            <option value="true">Not Configured</option>
            <option value="false">Configured</option>
          </select>
        </div>

        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('filter')"
          >
            Search
          </button>
        </div>
        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('refresh')"
          >
            Refresh
          </button>
        </div>
        <div class="col-auto mt-2">
          <button
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('download')"
          >
            Export csv
          </button>
        </div>
      </div>
    </div>

    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12 p-0">
      <div
        class="card-plain p-0"
        style="
          align-items: center;
          justify-content: center;
          display: flex;
          padding: 15px 0;
        "
      >
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Merchant Name</th>
                <th scope="col" class="text-center">Business Name</th>
                <th scope="col" class="text-center">Institution Name</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <!-- <th scope="col" class="text-center">Terminal ID 1</th> -->
                <th scope="col" class="text-center">Merchant ID</th>
                <th scope="col" class="text-center">Terminal Type</th>
                <th scope="col" class="text-center">Serial Number</th>
                <th scope="col" class="text-center">Configuration Status</th>
                <th scope="col" class="text-center">Configuration Date</th>
                <th scope="col" class="text-center">Sales Officer</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(terminal, index) in terminals" :key="terminal._id">
                <th class="text-center">
                  {{ limit * (currentPage - 1) + (index + 1) }}
                </th>
                <td class="text-center" style="text-transform: capitalize">
                  {{ terminal.tmsMerchantId.merchantName }}
                </td>
                <td class="text-center">
                  {{ terminal.tmsMerchantId.companyName }}
                </td>
                <td class="text-center">
                  {{ getInstitutionName(terminal.institutionId) }}
                </td>
                <td class="text-center">{{ terminal.terminalId }}</td>
                <!-- <td class="text-center">{{ terminal.terminalId1 }}</td> -->
                <td class="text-center">{{ terminal.merchantId }}</td>
                <td class="text-center">{{ terminal.terminalType }}</td>
                <td class="text-center">{{ terminal.serialNo }}</td>
                <td class="text-center text-uppercase">
                  <span
                    class="status"
                    :class="
                      terminal.forceConfig
                        ? 'status-disabled'
                        : 'status-enabled'
                    "
                  >
                    {{
                      terminal.forceConfig ? "NOT CONFIGURED" : "CONFIGURED"
                    }}</span
                  >
                </td>

                <td class="text-center">
                  {{ formatDate(terminal.configurationDate) || "--" }}
                </td>

                <td
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  {{ getSalesOfficerName(terminal.salesOfficerId) || "N/A" }}
                </td>

                <td class="text-center">
                  <virtual-dropdown
                    title="Options"
                    :is-open="terminal.isDropdownOpen"
                    @change="toggleDropdown(terminal._id)"
                  >
                    <div class="virtual-dropdown-list">
                      <div class="p-2 virtual-dropdown-item">
                        <img src="@/assets/img/fileIcon.svg" alt="file-icon" />
                        <router-link
                          :to="`/dashboard/view-ptspterminal/${
                            terminal.terminalId
                              ? terminal.terminalId
                              : terminal.serialNo
                          }`"
                          >View Details</router-link
                        >
                      </div>
                      <div
                        class="p-2 virtual-dropdown-item"
                        style="color: #65b3c7"
                        @click="openCreateModal(terminal)"
                      >
                        <img
                          src="@/assets/img/postAddIcon.svg"
                          alt="post-icon"
                        />

                        View Virtual Account
                      </div>
                    </div>
                  </virtual-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn btn-primary"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button
          class="btn btn-primary"
          :disabled="!hasNextPage"
          @click="refresh('next')"
        >
          Next
        </button>
      </div>

      <div class="pl-2">
        <div class="btn btn-primary">Total Records: {{ totalDocs }}</div>
      </div>
    </div>

    <CreateTerminalVirtualAccount
      :isVisible="showCreateModal"
      @close="closeCreateModal"
      :terminalDetails="terminalDetails"
    />
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import CreateTerminalVirtualAccount from "./Modals/CreateTerminalVirtualAccount.vue";

export default {
  components: {
    CreateTerminalVirtualAccount,
  },

  data() {
    return {
      error: false,
      terminals: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      currentPage: 1,
      totalDocs: 0,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      searchValues: {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
      },
      selectedValue: "",
      download: false,
      userType: localStorage.getItem("userType"),
      allSalesOfficers: [],
      allInstitutions: [],
      showCreateModal: false,
      terminalDetails: {},
      terminalId: null,
    };
  },
  computed: {
    ...mapState(["utils"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      // return this.userType === 'super-admin';
    },
  },
  methods: {
    ...mapActions(["getMerchants"]),

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD, hh:mm:ss");
    },

    toggleDropdown(id) {
      this.terminals = this.terminals.map((terminal) => {
        if (terminal._id === id) {
          terminal.isDropdownOpen = !terminal.isDropdownOpen;
        } else {
          terminal.isDropdownOpen = false;
        }
        return terminal;
      });
    },

    async refresh(mode) {
      try {
        this.loading = true;
        this.errorMsg = "";
        this.error = false;
        let payload = {
          page: this.page,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "refresh":
            this.currentPage = 1;
            payload = { page: this.page };
            this.selectedValue = "";
            this.searchValues = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/terminals/institution`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.terminals);
          fileDownload(csvTran, "terminals.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            limit,
            nextPage,
            page,
            prevPage,
            totalDocs,
            totalPages,
          } = res.data.terminals;
          this.terminals = docs;
          this.limit = limit;
          this.page = page;
          this.totalDocs = totalDocs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Terminals";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
      };
    },

    getMerchantName(id) {
      const merchant = this.utils.merchants.filter((el) => el._id === id);
      return merchant.length !== 0 ? merchant[0].merchantName : "";
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },

    async getAllInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/get-institutions`,
        );

        this.allInstitutions = res.data.institutions.docs;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Institutions",
          });
        }
      }
    },

    getInstitutionName(id) {
      const institution = this.allInstitutions.find(
        (institution) => institution._id === id,
      );
      if (!institution) return "";
      return institution ? institution.institutionName : "";
    },

    async openCreateModal(rowterminal) {
      this.terminalDetails = rowterminal;
      console.log("terminalDetails", this.terminalDetails);
      this.showCreateModal = true;
    },

    closeCreateModal() {
      this.showCreateModal = false;
      this.terminalDetails = {};
    },
  },
  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh();
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/terminals/institution`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        limit,
        nextPage,
        page,
        prevPage,
        totalDocs,
        totalPages,
      } = res.data.terminals;
      this.terminals = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.limit = limit;
      this.page = page;
      this.totalDocs = totalDocs;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Terminals";
    }
    this.loading = false;
    this.getMerchants();
    this.getSalesOfficers();
    this.getAllInstitutions();
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}

.virtual-dropdown-list {
  background: white;
  position: absolute;
  border-radius: 8px;
  padding: 4px;
  width: max-content;
  font-size: 0.875rem;
  right: 0;
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  color: #23242f;
}

.virtual-dropdown-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}
li {
  list-style: none;
}

.pagination {
  justify-content: space-between;
  width: 100%;
}

.card-body {
  padding: 15px 0px !important;
}
</style>
